import Facade from '@/Facade'
import { IURLParameters } from '@/modules'
import { Utilities } from '@base/utils/Utilities'

export class URLParser {
    public readonly urlData: IURLParameters

    public constructor() {
        this.urlData = {
            gameCode: null,
            game_code: null,
            platform: null,
            casinoToken: null,
            currency: null,
            language: null,
            playerUid: null,
            realityCheckTime: null,
            extParams: null,
            ext_params: null,
            customer: null,
            playForFun: true,
            maxBet: true,
            autoSpin: 'true',
            quickSpin: 'true',
            forceCoinAmount: false,
            lobby_url: null,
            lobbyUrl: null,
            home_url: null,
            homeUrl: null,
            deposit_url: null,
            depositUrl: null,
            amount_type: null,
            session_id: null,
            site_code: null,
            siteCode: null,
            network_code: null,
            networkCode: null,
            dir: null,
            hide_promo_btn: null,
            hidePromoBtn: null,
        }

        this.urlData.gameCode = Utilities.getUrlParam('game_code', this.urlData.gameCode)
        this.urlData.game_code = Utilities.getUrlParam('game_code', this.urlData.game_code)
        this.urlData.platform = Utilities.getUrlParam('platform', this.urlData.platform)
        this.urlData.casinoToken = Utilities.getUrlParam('casino_token', this.urlData.casinoToken)
        this.urlData.currency = Utilities.getUrlParam('currency', this.urlData.currency)
        this.urlData.language = Utilities.getUrlParam('language', this.urlData.language)
        this.urlData.playForFun = Utilities.getUrlParam('play_for_fun', this.urlData.playForFun) !== 'false'
        this.urlData.playerUid = Utilities.getUrlParam('player_uid', this.urlData.playerUid)
        this.urlData.maxBet = Utilities.getUrlParam('max_bet', this.urlData.maxBet) !== 'false'
        this.urlData.customer = Utilities.getUrlParam('customer', this.urlData.customer)
        this.urlData.realityCheckTime = Utilities.getUrlParam('reality_check_time', this.urlData.realityCheckTime)
        this.urlData.forceCoinAmount = Utilities.getUrlParam('force_coin_amount', this.urlData.forceCoinAmount)
        this.urlData.extParams = Utilities.searchParam('ext_params')
        this.urlData.autoSpin = Utilities.getUrlParam('auto_spin', this.urlData.autoSpin)
        this.urlData.quickSpin = Utilities.getUrlParam('quick_spin', this.urlData.quickSpin)
        this.urlData.lobby_url = Utilities.getUrlParam('lobby_url', this.urlData.lobby_url)
        this.urlData.lobbyUrl = Utilities.getUrlParam('lobbyUrl', this.urlData.lobbyUrl)
        this.urlData.home_url = Utilities.getUrlParam('home_url', this.urlData.home_url)
        this.urlData.homeUrl = Utilities.getUrlParam('homeUrl', this.urlData.homeUrl)
        this.urlData.deposit_url = Utilities.getUrlParam('deposit_url', this.urlData.deposit_url)
        this.urlData.depositUrl = Utilities.getUrlParam('depositUrl', this.urlData.depositUrl)
        this.urlData.amount_type = Utilities.getUrlParam('amount_type', this.urlData.amount_type)
        this.urlData.session_id = Utilities.getUrlParam('session_id', this.urlData.session_id)
        this.urlData.site_code = Utilities.getUrlParam('site_code', this.urlData.site_code)
        this.urlData.siteCode = Utilities.getUrlParam('siteCode', this.urlData.siteCode)
        this.urlData.network_code = Utilities.getUrlParam('network_code', this.urlData.network_code)
        this.urlData.networkCode = Utilities.getUrlParam('networkCode', this.urlData.networkCode)
        this.urlData.dir = Utilities.getUrlParam('dir', this.urlData.dir)
        this.urlData.hide_promo_btn = Utilities.getUrlParam('hide_promo_btn', this.urlData.hide_promo_btn)
        this.urlData.hidePromoBtn = Utilities.getUrlParam('hidePromoBtn', this.urlData.hidePromoBtn)

        // Normalize aliases so downstream code reading snake_case keeps working.
        this.urlData.lobby_url = this.urlData.lobby_url || this.urlData.lobbyUrl
        this.urlData.home_url = this.urlData.home_url || this.urlData.homeUrl
        this.urlData.deposit_url = this.urlData.deposit_url || this.urlData.depositUrl

        if (Utilities.getUrlParam('play_for_fun', null) == null && this.urlData.playerUid != null) {
            this.urlData.playForFun = false
        }

        Facade.urlParams = this.urlData
    }
}
